function usernameChangedAtMillis(user) {
  const value = user?.usernameChangedAt ?? user?.username_changed_at;
  if (!value) return null;

  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : null;
}

function sameUser(left, right) {
  const leftId = String(left?.id || "").trim();
  const rightId = String(right?.id || "").trim();
  return Boolean(leftId && rightId && leftId === rightId);
}

export function mergeUserPreservingNewerUsername(currentUser, incomingUser) {
  if (!incomingUser || typeof incomingUser !== "object") return currentUser;
  if (!currentUser || typeof currentUser !== "object") return incomingUser;
  if (!sameUser(currentUser, incomingUser)) return incomingUser;

  const currentChangedAt = usernameChangedAtMillis(currentUser);
  const incomingChangedAt = usernameChangedAtMillis(incomingUser);
  const shouldPreserveCurrentUsername = Boolean(
    currentUser.username &&
      (!incomingUser.username ||
        (currentChangedAt !== null &&
          (incomingChangedAt === null || incomingChangedAt < currentChangedAt)))
  );

  if (!shouldPreserveCurrentUsername) return incomingUser;

  const mergedUser = {
    ...incomingUser,
    username: currentUser.username,
    usernameChangedAt:
      currentUser.usernameChangedAt ?? currentUser.username_changed_at,
  };

  if ("username_changed_at" in incomingUser || "username_changed_at" in currentUser) {
    mergedUser.username_changed_at =
      currentUser.username_changed_at ?? currentUser.usernameChangedAt;
  }

  return mergedUser;
}

export function mergeUserDirectoryPreservingNewerUsernames(
  currentUsers,
  incomingUsers
) {
  if (!Array.isArray(incomingUsers)) return [];
  const currentById = new Map(
    (Array.isArray(currentUsers) ? currentUsers : [])
      .filter((user) => user?.id)
      .map((user) => [user.id, user])
  );

  return incomingUsers.map((incomingUser) =>
    mergeUserPreservingNewerUsername(
      currentById.get(incomingUser?.id),
      incomingUser
    )
  );
}
